var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 15,
    viewBox: "0 0 33 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.104 2.272l14.977 9.456 14.976-9.456",
    stroke: "#506BCA",
    strokeWidth: 4
  })));
}
export default __webpack_public_path__ + "media/icons/blue-arrow-down-06409598.svg";
export { SvgBlueArrowDown as ReactComponent };